var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SuggestDialog',{attrs:{"is-icon":_vm.isIcon,"show-in-kebab-action":_vm.showInKebabAction,"disabled":_vm.disabled,"suggest-handler":_vm.suggestHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }